export const TEXT = {
  general: {
    m2: "m²",
  },
  navHeader: {
    siteSettings: "Site Settings",
    masterMaker: "Planner",
  },
  sidebarResults: {
    defaultTitle: "Collections",
    noRunners: "No runners",
    emptySearch: {
      part1Start: "Within",
      /* "Search for your location and define the property after selecting" */ part1Highlight:
        ' "Site Settings" ',
      part1End: "you will define your site." /* "on the top." */,

      part2Start:
        "Within" /* "Then you can start generating results with clicking on" */,
      part2Highlight: ' "Master.Maker" ',
      part2End:
        "you will define the required areas and start the automated generations.",

      part3:
        "Once the generation is completed, multiple results will appear here!",
    },
    site: {
      siteAreaTitle: "Site Area",
      siteAreaTooltip:
        "Site Area excluding non-buildable area (border off-set)",
      perimeterTitle: "Perimeter",
      perimeterTooltip: "Perimeter of the Site Area",
      borderTitle: "Border Offset",
      borderTooltip: "Distance for construction from the site's borders",
      heightTitle: "max. Construction Height",
      heightTooltip: "Maximum height for construction",
    },
    kpis: {
      totalBuildingAreaTitle: "Building Area",
      totalBuildingAreaTooltip:
        "This represents the sum of the area used by buildings.",
      totalBuiltUpAreaTitle: "Total Built-up Area",
      totalBuiltUpAreaTooltip:
        "This is the sum of the area used by buildings and paved areas (paths and docking stations).",
      greenAreaTitle: "Green Area",
      greenAreaTooltip:
        "This represents the un-utilized, and therefore potential green, area.",
      totalCostTitle: "Total Costs",
      totalCostTooltip:
        "Total costs of the site. Each value specified for each building in Master.Maker is multiplied by the area of the building to result in the building’s cost. Summed up for all specified buildings results in Total Costs.",
      areaBalanceTitle: "Area Balance by Function Type",
      areaBalanceTooltip:
        "Area of each Function Type in its total [m²] and in relation to each other [%].",
      buildingAreaTitle: "Building Area",
      buildingAreaTooltip:
        "Area for the one-storey Building. The building's aspect ratio is guided by the axis grid “24*12[m]” and its multiple.",
        buildingAreaCarParkingTitle: "Car Parking Area",
      buildingAreaCarParkingTooltip:
        "Area for Car Parking: the area is dimensioned for parallel parked cars by multiplying 19.2m2 with the “Nr. of Car Parks”.",
      buildingAreaOfficeTooltip:
        "Area for the one-storey Building. The building's aspect ratio is guided by the axis grid “13.5*9[m]” and its multiple.",
      heightTitle: "Building Height",
      heightTooltip:
        "The height of this building is calculated as follows: set value for “Inner Clearance Height” (default value 7 [m]) + 2 [m] as construction height of the roof's structure",
      heightOffice:
        "The height of this building is calculated as follows: set value for “Nr. Of Storeys” * 3[m] storey height + 2 [m] as construction height of the roof's structure",
      dockingSationsTitle: "Docking Stations",
      dockingSationsTooltip:
        "Entered amount of Docking Stations. For each entered Docking Station an area of 18m long and 2.6m is being calculated.",
      costTitle: "Costs",
      costTooltip:
        "The costs for this building are calculated as follows: Specified value [€/m2GFA] * Building Area [m²]",
        costCarParkingTooltip:
        "The costs for this area are calculated as follows: Specified value [€/m2GFA] * Car Parking Area [m²]",
      axisGrid: 'Axis Grid',
      axisGridTooltip: '',
      currentAxisGrid: "Select axis grid option",
      currentAxisGridTooltip: "The axis grid defines the spacing of structural elements in the building.",
      dimensions: 'Dimensions',
      dimensionsTooltip: '',
      dateTitle: "Generation Start Date",
      dateTooltip:
        "Generation Start Date",
    },
    deleteConfirm1:
      "Are you sure you want to delete the selected Generation?",
  },
  siteSettings: {
    locationTitle: "Location",
    locationTooltip:
      "Use the search bar on top of the map to navigate to your site. The entered address will be used as information within this project.",
    siteAreaTitle: "Site Area",
    siteAreaTooltip:
      "Using the bottom tool bar, you will draw the shape of your site on the map. The line will represent the sites borders - the necessary distances for constructions are subsequently queried. Existing constructions (i.e. buildings, streets, …) within the drawn shape will be erased and not considered during generation.",
    accessTitle: "Access",
    accessTooltip:
      "Select the site's border from with the site will be entered and exited.",
    regulationsTitle: "Regulations",
    borderTooltip:
      "Specify the minimum distance for construction from the site's borders.",
    heightTooltip: "Specify the maximum height for construction.",
  },
  planner: {
    tooltip:
      "Drag and drop required Function Types, each representing a building on your site. For each Function Type specific properties will be queried.",
    progressSiteTitle: "Site Area",
    progressBuildingsTitle: "Utilized Area",
    inputs: {
      functionTypeTooltip:
        "Select the Function Type this building shall represent. When changing, the requested input field may vary.",
        functionTypeCarParkingTooltip:
        "Select the Function Type this card shall represent. When changing, the requested input field may vary.",
      minAreaTooltip:
        "Define the minimum area for the one-storey Building. The building's aspect ratio will be guided by the axis grid “24*12[m]” and its multiple.",
      maxAreaTooltip:
        "Define the maximum area for the one-storey Building. The building's aspect ratio will be guided by the axis grid “24*12[m]” and its multiple.",
      minAreaOfficeTooltip:
        "Define the minimum area for the one-storey Building. The building's aspect ratio will be guided by the axis grid “13.5*9[m]” and its multiple.",
      maxAreaOfficeTooltip:
        "Define the maximum area for the one-storey Building. The building's aspect ratio will be guided by the axis grid “13.5*9[m]” and its multiple.",
      dockingStationsTooltip:
        "Enter the needed amount of Docking Stations. For each entered Docking Station an area of 18m long and 2.6m wide will be respected.",
      truckRequirementTooltip:
        "Specify the type of trucks using the entered docking stations for this building.",
      innerClearanceHeightTooltip:
        "Specify the minimum inner clearance height. The height for construction of the roof's structure will be added.",
      storeysTooltip:
        "Specify the number of storeys the office building shall represent.",
      costTooltip: "Enter the costs per m² of the gross floor area.",
      isolatedTooltip:
        "If this building shall be positioned with a specific distance to the other required buildings, tick the box.",
    },
    deleteConfirm1:
      "Are you sure you want to delete the selected Function Type?",
      deleteConfirm2:
      "This action cannot be undone.",
    connections: {
      adjacentTitle: "Connection Adjacent",
      adjacentTooltip:
        "When connecting two Function Type by the connection Type “Adjacent”, these two Function Types will be positioned in close distance to each other. If either, or both, of the Function Types have ticked the box “Isolated”, there will be set a distance amongst the areas. If “Isolated” is not selected, the two Function Types will be touching.",
    },
    new: "",
  },

  // You can keep adding other sections:
  // plannerPage: {...}
  // siteSettingsPage: {...}
};
